import { render, staticRenderFns } from "./PrimaryOrgSettingsModal.vue?vue&type=template&id=54b1e258&scoped=true"
import script from "./PrimaryOrgSettingsModal.vue?vue&type=script&lang=js"
export * from "./PrimaryOrgSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./PrimaryOrgSettingsModal.vue?vue&type=style&index=0&id=54b1e258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b1e258",
  null
  
)

export default component.exports